import React from "react";
import ChatPane from "./ChatPane";
import MobileMicFab from "./MobileMicFab";

/**
 * Responsive chat container.
 * - Desktop (lg+): persistent left rail (400px wide).
 * - Mobile / tablet: floating microphone FAB on the right edge + history modal
 *   (replaces the older bottom drawer to avoid the chat box overlap with view
 *   options on small screens).
 */
export default function ChatDrawer({
  messages,
  onSend,
  loading,
  designSummary,
  suggestedActions = [],
  onClearSuggestions,
  buildQueue = [],
  snapshotChip,
  quickMode = false,
  onToggleQuickMode,
  quickModeFlash = false,
}) {
  return (
    <>
      {/* Desktop left rail */}
      <div
        className="hidden lg:block absolute top-0 left-0 bottom-0 w-[400px] z-10 border-r border-zinc-800 bg-zinc-950/92 backdrop-blur-md"
        data-testid="chat-rail-desktop"
      >
        <ChatPane
          messages={messages}
          onSend={onSend}
          loading={loading}
          designSummary={designSummary}
          suggestedActions={suggestedActions}
          onClearSuggestions={onClearSuggestions}
          buildQueue={buildQueue}
          snapshotChip={snapshotChip}
          quickMode={quickMode}
          onToggleQuickMode={onToggleQuickMode}
          quickModeFlash={quickModeFlash}
        />
      </div>

      {/* Mobile floating mic FAB + history modal */}
      <MobileMicFab
        messages={messages}
        onSend={onSend}
        loading={loading}
        suggestedActions={suggestedActions}
        onClearSuggestions={onClearSuggestions}
        buildQueue={buildQueue}
        snapshotChip={snapshotChip}
      />
    </>
  );
}
